import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { getInternationalizedImage } from '../images/internationalizedImages';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageImageCaption = ({
  messageKey
}) => {
  const {
    imageKey,
    altText
  } = getMessage(messageKey);
  const locale = getApplicationLocale();
  const imageUrl = getInternationalizedImage(imageKey, locale);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(imageUrl);
  const attrs = {
    responsive: true,
    onLoad: handleImageLoaded,
    imageLoaded,
    src: imageUrl
  };
  if (Array.isArray(imageUrl)) {
    attrs.src = imageUrl[imageUrl.length - 1];
    attrs.srcSet = imageUrl.map((src, index) => `${src} ${400 * (index + 1)}w`).join(', ');
    attrs.sizes = '(max-width: 1200px) 100vw, 1200px';
  } else {
    attrs.src = imageUrl;
  }
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    disable: isTransitionAndAnimationsDisabled(),
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(BaseMessageCaption, {
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(Image, Object.assign({}, attrs, {
        alt: altText,
        marginBlock: "0",
        marginInline: "auto"
      }))
    })
  });
};
export default MessageImageCaption;